import toast from "react-hot-toast";
import PropTypes from "prop-types";
import ModalV2 from "../../../../components/ModalV2";
import { useState } from "react";
import useModal from "../../../../hooks/useModal";
import { Button, Input } from "@oc-labs/wt-storybook";
import useCompany from "../../../../hooks/useCompany";
import useRwas from "../../../../hooks/useRwas";


export default function NFTCreateModal({ rwaId, reloadNfts }) {
  const { activeCompany: company } = useCompany();
  const { close } = useModal("nft-create-modal");
  const [quantity, setQuantity] = useState(1);
  const [isCreating, setIsCreating] = useState(false);
  const { createRwaNft } = useRwas();

  const handleCreateRwa = async () => {
    if (isCreating) return;
    setIsCreating(true);
    try {
      const count = Number(quantity);
      for (let i = 0; i < count; i++) {
        await createRwaNft(company.id, rwaId, {
          companyId: company.id,
        });
      }
      reloadNfts();
      toast.success("RWA NFT created successfully");
    } catch (error) {
      console.error("Error creating NFTs:", error);
      toast.error("Failed to create NFTs");
    } finally {
      setIsCreating(false);
      setQuantity(1);
      close();
    }
  };

  return (
    <ModalV2
      name="nft-create-modal"
      title={isCreating ? "" : "Create RWA NFT"}
      onClose={isCreating ? () => {} : undefined}
    >
      {isCreating ? (
        <div className="p-6 flex flex-col items-center gap-4 min-w-[280px]">
          <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-gray-900" />
          <p className="text-base font-medium text-gray-800">
            Your NFTs are being created…
          </p>
          <p className="text-sm text-gray-500">This may take a moment. Please wait.</p>
        </div>
      ) : (
        <div className="p-6">
          <Input
            placeholder="Enter quantity"
            className="w-full p-2 border border-gray-300 rounded-md"
            type="number"
            label="Quantity"
            value={quantity}
            onChange={(e) =>
              setQuantity(isNaN(e.target.value) ? 1 : Number(e.target.value))
            }
          />
          <Button onClick={handleCreateRwa} className="mt-4">
            Create NFT{quantity > 1 ? `s (${quantity})` : ""}
          </Button>
        </div>
      )}
    </ModalV2>
  );
}

NFTCreateModal.propTypes = {
  rwaId: PropTypes.string.isRequired,
  reloadNfts: PropTypes.func,
};
